module.exports = __webpack_public_path__ + "static/media/catapult-poster.696fa6f1.png";